import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaAlternativa = (): TabelaColuna => ({
  Chave: 'alternativa',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Alternativa</div>
})
